import React, { useState, useEffect } from "react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import Select from "react-select";
import Chart from "react-apexcharts";
import SiteWrapper from "../../SiteWrapper.react";
import axios from "axios";
import * as conf from "../../config/config";

const GpsPatiosCirculacion = () => {
  const [gpsList, setGpsList] = useState([]);
  const [gpsListFiltrados, setGpsListFiltrados] = useState([]);
  const [gpsDisponibles, setGpsDisponibles] = useState([]);
  const [gpsSeleccionado, setGpsSeleccionado] = useState(null);
  
  // Filtros
  const [localidadOpciones, setLocalidadOpciones] = useState([]);
  const [localidadOpcion, setLocalidadOpcion] = useState({ value: 0, label: "Todos" });
  
  const [paisOpciones, setPaisOpciones] = useState([]);
  const [paisOpcion, setPaisOpcion] = useState({ value: 0, label: "Todos" });

  // Cargar datos inicial
  useEffect(() => {
    getfuntion("get", [], "", "gps/dash", "patios_circulacion");
    cargarGpsDisponibles();
  }, []);

  // Aplicar filtros cuando cambien
  useEffect(() => {
    filtro();
  }, [localidadOpcion, paisOpcion, gpsList]);

  const getfuntion = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "") => {
    Crud_Catalogos(catalogo, "home", metodo, id, obj, "", stateVar, "", [])
      .then((returnVal) => {
        if (metodo === "get" && stateVar === "patios_circulacion") {
          if (returnVal) {
            console.log("Datos recibidos del backend:", returnVal);
            
            //  CALCULAR días, color y categoría en el frontend
            const fechaActual = new Date().getTime();
            const gpsListProcesada = returnVal.map(gps => {
              let diasSinReporte = null;
              let color = null;
              let categoriaDias = null;

              // Si tiene deviceactivity, calcular días
              if (gps.deviceactivity) {
                const fechaDevice = new Date(gps.deviceactivity).getTime();
                diasSinReporte = Math.round((fechaActual - fechaDevice) / (1000 * 60 * 60 * 24));
                
                // Calcular color SOLO para Disponible y Por Recuperar (NO para Instalado)
                if (gps.gpsEstatus !== 'Instalado') {
                  if (diasSinReporte <= 2) {
                    color = 'green';
                    categoriaDias = '0-2 días';
                  } else if (diasSinReporte <= 10) {
                    color = 'yellow';
                    categoriaDias = '3-10 días';
                  } else {
                    color = 'red';
                    categoriaDias = 'Más de 10 días';
                  }
                }
              } else {
                // Sin deviceactivity
                if (gps.gpsEstatus !== 'Instalado') {
                  color = 'gray';
                  categoriaDias = 'Sin reporte';
                }
              }

              return {
                ...gps,
                diasSinReporte,
                color,
                categoriaDias
              };
            });

            console.log("Datos procesados con colores:", gpsListProcesada);
            setGpsList(gpsListProcesada);
            generarOpcionesFiltros(gpsListProcesada);
          }
        }
      })
      .catch((err) => {
        console.error("Error al cargar datos:", err);
      });
  };

  // Cargar GPS disponibles (todos los GPS para poder filtrar)
  const cargarGpsDisponibles = () => {
    Crud_Catalogos("gps", "home", "get", "", [], "", "", "", [])
      .then((returnVal) => {
        if (returnVal) {
          console.log("Todos los GPS:", returnVal); // Debug
          // Filtrar solo GPS que NO están en patios (patios = 0 o null o false)
          const gpsNoPatios = returnVal.filter(gps => !gps.patios || gps.patios === 0);
          console.log("GPS disponibles para patios:", gpsNoPatios); // Debug
          
          const opciones = gpsNoPatios.map(gps => ({
            value: gps.id,
            label: `${gps.nombre} - ${gps.imei}`
          }));
          setGpsDisponibles(opciones);
        }
      })
      .catch((err) => {
        console.error("Error al cargar GPS disponibles:", err);
      });
  };

  // Agregar GPS a patios (patios = true)
  const agregarGpsPatios = () => {
    if (!gpsSeleccionado) {
      alert("Selecciona un GPS");
      return;
    }

    console.log("Intentando agregar GPS:", gpsSeleccionado); // Debug

    const token = sessionStorage.getItem('tok');
    
    axios.put(`${conf.api_raiz}gps/patios/${gpsSeleccionado.value}?patios=true`, null, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      console.log("Respuesta del servidor:", response.data); // Debug
      alert("GPS agregado a patios correctamente");
      setGpsSeleccionado(null);
      // Recargar datos
      getfuntion("get", [], "", "gps/dash", "patios_circulacion");
      cargarGpsDisponibles();
    })
    .catch(error => {
      console.error('Error completo:', error); // Debug más detallado
      console.error('Respuesta del error:', error.response?.data); // Debug
      alert(`Error al agregar GPS a patios: ${error.response?.data || error.message}`);
    });
  };

  // Eliminar GPS de patios (patios = false)
  const eliminarGpsPatios = (gpsId, gpsNombre) => {
    if (!window.confirm(`¿Estás seguro de eliminar ${gpsNombre} de patios?`)) {
      return;
    }

    const token = sessionStorage.getItem('tok');
    
    axios.put(`${conf.api_raiz}gps/patios/${gpsId}?patios=false`, null, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      alert("GPS eliminado de patios correctamente");
      // Recargar datos
      getfuntion("get", [], "", "gps/dash", "patios_circulacion");
      cargarGpsDisponibles();
    })
    .catch(error => {
      console.error('Error al eliminar GPS de patios:', error);
      alert("Error al eliminar GPS de patios");
    });
  };

  const generarOpcionesFiltros = (data) => {
    const localidades = {};
    const paises = {};

    data.forEach((gps) => {
      // Extraer localidades únicas (excluyendo "Sin corredor" o null)
      if (gps.corredor && gps.corredor !== 'Sin corredor' && !localidades[gps.corredor]) {
        localidades[gps.corredor] = {
          value: gps.corredor,
          label: gps.corredor
        };
      }
      
      // Extraer países únicos (excluyendo "Sin país" o null)
      if (gps.pais && gps.pais !== 'Sin país' && !paises[gps.pais]) {
        paises[gps.pais] = {
          value: gps.pais,
          label: gps.pais
        };
      }
    });

    setLocalidadOpciones([
      { value: 0, label: "Todos" },
      ...Object.values(localidades)
    ]);
    
    setPaisOpciones([
      { value: 0, label: "Todos" },
      ...Object.values(paises)
    ]);
  };

  const filtro = () => {
    let gpssTemp = [...gpsList];

    if (localidadOpcion.value) {
      gpssTemp = gpssTemp.filter(g => g.corredor === localidadOpcion.label);
    }

    if (paisOpcion.value) {
      gpssTemp = gpssTemp.filter(g => g.pais === paisOpcion.label);
    }

    setGpsListFiltrados(gpssTemp);
  };

  // Función para obtener datos de DISPONIBLES (estatus = Disponible)
  const getDisponibles = () => {
    const disponibles = gpsListFiltrados.filter(g => g.gpsEstatus === 'Disponible');
    
    const porDias = {
      verde: disponibles.filter(g => g.color === 'green').length,
      amarillo: disponibles.filter(g => g.color === 'yellow').length,
      rojo: disponibles.filter(g => g.color === 'red').length,
      sinReporte: disponibles.filter(g => g.color === 'gray').length
    };

    // Agrupar por localidad
    const porLocalidad = {};
    disponibles.forEach(gps => {
      const loc = gps.corredor || 'Sin localidad';
      if (!porLocalidad[loc]) {
        porLocalidad[loc] = { total: 0, verde: 0, amarillo: 0, rojo: 0, gris: 0 };
      }
      porLocalidad[loc].total++;
      if (gps.color === 'green') porLocalidad[loc].verde++;
      if (gps.color === 'yellow') porLocalidad[loc].amarillo++;
      if (gps.color === 'red') porLocalidad[loc].rojo++;
      if (gps.color === 'gray') porLocalidad[loc].gris++;
    });

    return {
      total: disponibles.length,
      porDias,
      porLocalidad
    };
  };

  // Función para obtener datos de INSTALADOS (estatus = Instalado)
  const getInstalados = () => {
    const instalados = gpsListFiltrados.filter(g => g.gpsEstatus === 'Instalado');
    
    // Agrupar por plataforma
    const porPlataforma = {};
    instalados.forEach(gps => {
      const plat = gps.plataforma || 'Sin plataforma';
      if (!porPlataforma[plat]) {
        porPlataforma[plat] = 0;
      }
      porPlataforma[plat]++;
    });

    return {
      total: instalados.length,
      porPlataforma
    };
  };

  // Función para obtener datos de POR RECUPERAR (estatus = Por Recuperar)
  const getPorRecuperar = () => {
    const porRecuperar = gpsListFiltrados.filter(g => g.gpsEstatus === 'Por Recuperar');
    
    const porDias = {
      verde: porRecuperar.filter(g => g.color === 'green').length,
      amarillo: porRecuperar.filter(g => g.color === 'yellow').length,
      rojo: porRecuperar.filter(g => g.color === 'red').length,
      sinReporte: porRecuperar.filter(g => g.color === 'gray').length
    };

    // Agrupar por transporte (corredor)
    const porTransporte = {};
    porRecuperar.forEach(gps => {
      const trans = gps.corredor || 'Sin transporte';
      if (!porTransporte[trans]) {
        porTransporte[trans] = { total: 0, verde: 0, amarillo: 0, rojo: 0, gris: 0 };
      }
      porTransporte[trans].total++;
      if (gps.color === 'green') porTransporte[trans].verde++;
      if (gps.color === 'yellow') porTransporte[trans].amarillo++;
      if (gps.color === 'red') porTransporte[trans].rojo++;
      if (gps.color === 'gray') porTransporte[trans].gris++;
    });

    return {
      total: porRecuperar.length,
      porDias,
      porTransporte
    };
  };

  const disponibles = getDisponibles();
  const instalados = getInstalados();
  const porRecuperar = getPorRecuperar();

  return (
    <SiteWrapper>
      <div className="container-fluid">
        {/* Título */}
        <div className="row justify-content-center" style={{ margin: "16px" }}>
          <div className="col-12 text-center">
            <h1>Circulación de activos - GPS Patios</h1>
            <p className="text-muted">Dashboard de monitoreo de GPS</p>
          </div>
        </div>

        {/* Filtros */}
        <div className="row mb-4">
          <div className="col-md-5">
            <div className="form-group">
              <label><strong>Localidad</strong></label>
              <Select
                value={localidadOpcion}
                onChange={(e) => setLocalidadOpcion(e)}
                options={localidadOpciones}
              />
            </div>
          </div>
          <div className="col-md-5">
            <div className="form-group">
              <label><strong>País</strong></label>
              <Select
                value={paisOpcion}
                onChange={(e) => setPaisOpcion(e)}
                options={paisOpciones}
              />
            </div>
          </div>
          <div className="col-md-2 d-flex align-items-end">
            <button 
              className="btn btn-secondary btn-block"
              onClick={() => {
                setLocalidadOpcion({ value: 0, label: "Todos" });
                setPaisOpcion({ value: 0, label: "Todos" });
              }}
            >
              Limpiar filtros
            </button>
          </div>
        </div>



        {/* Dashboard principal - 3 columnas */}
        <div className="row">
          {/* COLUMNA 1: DISPONIBLES */}
          <div className="col-md-4">
            <div className="card mb-4 shadow-sm">
              <div className="card-header bg-success text-white">
                <h4 className="mb-0">
                  <i className="fe fe-check-circle mr-2"></i>
                  Disponibles
                </h4>
              </div>
              <div className="card-body">
                <h2 className="text-center mb-3">{disponibles.total}</h2>
                
                {/* Gráfica de dona - por días */}
                {disponibles.total > 0 ? (
                  <>
                    <Chart
                      series={[
                        disponibles.porDias.verde,
                        disponibles.porDias.amarillo,
                        disponibles.porDias.rojo,
                        disponibles.porDias.sinReporte
                      ]}
                      options={{
                        chart: { type: 'donut' },
                        labels: ['0-2 días', '3-10 días', 'Más de 10 días', 'Sin reporte'],
                        colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                        legend: { position: 'bottom' },
                        dataLabels: {
                          enabled: true,
                          formatter: function (val) {
                            return val.toFixed(0) + "%"
                          }
                        }
                      }}
                      type="donut"
                      height={250}
                    />

                    {/* Gráfica de barras horizontales - por localidad */}
                    {Object.keys(disponibles.porLocalidad).length > 0 && (
                      <div className="mt-4">
                        <h6>Por Localidad</h6>
                        <Chart
                          series={[
                            {
                              name: '0-2 días',
                              data: Object.values(disponibles.porLocalidad).map(l => l.verde)
                            },
                            {
                              name: '3-10 días',
                              data: Object.values(disponibles.porLocalidad).map(l => l.amarillo)
                            },
                            {
                              name: 'Más de 10 días',
                              data: Object.values(disponibles.porLocalidad).map(l => l.rojo)
                            },
                            {
                              name: 'Sin reporte',
                              data: Object.values(disponibles.porLocalidad).map(l => l.gris)
                            }
                          ]}
                          options={{
                            chart: { 
                              type: 'bar', 
                              stacked: true,
                              toolbar: { show: false }
                            },
                            plotOptions: {
                              bar: { 
                                horizontal: true,
                                barHeight: '60%', // Reduce el grosor de las barras
                                dataLabels: {
                                  position: 'center'
                                }
                              }
                            },
                            xaxis: {
                              categories: Object.keys(disponibles.porLocalidad),
                              labels: {
                                style: {
                                  fontSize: '11px'
                                }
                              }
                            },
                            yaxis: {
                              labels: {
                                style: {
                                  fontSize: '11px'
                                },
                                maxWidth: 120 // Ajusta el ancho máximo del texto
                              }
                            },
                            colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                            legend: {
                              position: 'bottom',
                              fontSize: '11px'
                            }
                          }}
                          type="bar"
                          height={Object.keys(disponibles.porLocalidad).length * 35} // Altura dinámica: 35px por localidad
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <p className="text-center text-muted">No hay GPS disponibles</p>
                )}
              </div>
            </div>
          </div>

          {/* COLUMNA 2: INSTALADOS */}
          <div className="col-md-4">
            <div className="card mb-4 shadow-sm">
              <div className="card-header bg-primary text-white">
                <h4 className="mb-0">
                  <i className="fe fe-map-pin mr-2"></i>
                  Instalados
                </h4>
              </div>
              <div className="card-body">
                <h1 className="display-3 text-primary text-center">{instalados.total}</h1>
                <p className="text-muted text-center">GPS activos</p>

                {/* Gráfica de dona - por plataforma */}
                {instalados.total > 0 && Object.keys(instalados.porPlataforma).length > 0 && (
                  <div className="mt-4">
                    <h6>Plataformas</h6>
                    <Chart
                      series={Object.values(instalados.porPlataforma)}
                      options={{
                        chart: { type: 'donut' },
                        labels: Object.keys(instalados.porPlataforma),
                        legend: { position: 'bottom' },
                        dataLabels: {
                          enabled: true,
                          formatter: function (val) {
                            return val.toFixed(1) + "%"
                          }
                        }
                      }}
                      type="donut"
                      height={300}
                    />

                    {/* Lista de plataformas con porcentajes */}
                    <div className="mt-3">
                      <ul className="list-unstyled">
                        {Object.entries(instalados.porPlataforma)
                          .sort((a, b) => b[1] - a[1]) // Ordenar de mayor a menor
                          .map(([plataforma, cantidad]) => {
                            const porcentaje = ((cantidad / instalados.total) * 100).toFixed(1);
                            return (
                              <li key={plataforma} className="mb-2 d-flex justify-content-between">
                                <span>• {plataforma}</span>
                                <strong>{porcentaje}%</strong>
                              </li>
                            );
                          })}
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* COLUMNA 3: POR RECUPERAR */}
          <div className="col-md-4">
            <div className="card mb-4 shadow-sm">
              <div className="card-header bg-warning text-dark">
                <h4 className="mb-0">
                  <i className="fe fe-alert-triangle mr-2"></i>
                  Por recuperar
                </h4>
              </div>
              <div className="card-body">
                <h2 className="text-center mb-3">{porRecuperar.total}</h2>
                
                {/* Gráfica de dona - por días */}
                {porRecuperar.total > 0 ? (
                  <>
                    <Chart
                      series={[
                        porRecuperar.porDias.verde,
                        porRecuperar.porDias.amarillo,
                        porRecuperar.porDias.rojo,
                        porRecuperar.porDias.sinReporte
                      ]}
                      options={{
                        chart: { type: 'donut' },
                        labels: ['0-2 días', '3-10 días', 'Más de 10 días', 'Sin reporte'],
                        colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                        legend: { position: 'bottom' },
                        dataLabels: {
                          enabled: true,
                          formatter: function (val) {
                            return val.toFixed(0) + "%"
                          }
                        }
                      }}
                      type="donut"
                      height={250}
                    />

                    {/* Gráfica de barras horizontales - por transporte */}
                    {Object.keys(porRecuperar.porTransporte).length > 0 && (
                      <div className="mt-4">
                        <h6>Por Transporte</h6>
                        <Chart
                          series={[
                            {
                              name: '0-2 días',
                              data: Object.values(porRecuperar.porTransporte).map(t => t.verde)
                            },
                            {
                              name: '3-10 días',
                              data: Object.values(porRecuperar.porTransporte).map(t => t.amarillo)
                            },
                            {
                              name: 'Más de 10 días',
                              data: Object.values(porRecuperar.porTransporte).map(t => t.rojo)
                            },
                            {
                              name: 'Sin reporte',
                              data: Object.values(porRecuperar.porTransporte).map(t => t.gris)
                            }
                          ]}
                          options={{
                            chart: { 
                              type: 'bar', 
                              stacked: true,
                              toolbar: { show: false }
                            },
                            plotOptions: {
                              bar: { 
                                horizontal: true,
                                barHeight: '60%', // Reduce el grosor de las barras
                                dataLabels: {
                                  position: 'center'
                                }
                              }
                            },
                            xaxis: {
                              categories: Object.keys(porRecuperar.porTransporte),
                              labels: {
                                style: {
                                  fontSize: '11px'
                                }
                              }
                            },
                            yaxis: {
                              labels: {
                                style: {
                                  fontSize: '11px'
                                },
                                maxWidth: 120 // Ajusta el ancho máximo del texto
                              }
                            },
                            colors: ['#28a745', '#ffc107', '#dc3545', '#6c757d'],
                            legend: {
                              position: 'bottom',
                              fontSize: '11px'
                            }
                          }}
                          type="bar"
                          height={Object.keys(porRecuperar.porTransporte).length * 35} // Altura dinámica: 35px por transporte
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <p className="text-center text-muted">No hay GPS por recuperar</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Resumen general */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <h5>Resumen General</h5>
                <div className="row text-center">
                  <div className="col-md-3">
                    <h3 className="text-success">{disponibles.total}</h3>
                    <p>Disponibles</p>
                  </div>
                  <div className="col-md-3">
                    <h3 className="text-primary">{instalados.total}</h3>
                    <p>Instalados</p>
                  </div>
                  <div className="col-md-3">
                    <h3 className="text-warning">{porRecuperar.total}</h3>
                    <p>Por Recuperar</p>
                  </div>
                  <div className="col-md-3">
                    <h3 className="text-info">{gpsListFiltrados.length}</h3>
                    <p>Total GPS Patios</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SiteWrapper>
  );
};

export default GpsPatiosCirculacion;